import { createMuiTheme } from "@material-ui/core/styles";
import orange from "@material-ui/core/colors/orange";
import red from "@material-ui/core/colors/red";

const ImtbikeTheme = createMuiTheme({
  palette: {
    primary: orange,
    secondary: orange,
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Arial",
      "sans-serif"
    ].join(",")
  },
  overrides: {
    MuiLinearProgress: {
      barColorPrimary: {
        backgroundColor: "oldlace"
      },

      colorPrimary: {
        backgroundColor: "orange"
      },
      colorSecondary: {
        backgroundColor: "oldlace"
      }
    },

    MuiSwitch: {
      colorPrimary: {
        "&$checked": {
          color: "orange",
          "& + $bar": {
            backgroundColor: "orange"
          }
        }
      }
    },
    MuiTabs: {
      indicator: {
        backgroundColor: "orange"
      }
    },
    MuiSvgIcon: {
      root: {
        // Name of the rule
        color: "black" // Some CSS
      }
    },
    Link: {
      root: {
        // Name of the rule
        color: "#000000", // Some CSS
        backgroundColor: "white",
        fontSize: "16px"
      }
    },
    MuiListItem: {
      root: {
        fontSize: "16px"
      }
    },
    MuiTableCell: {
      root: {
        fontSize: "16px !important"
      }
    },
    MuiTypography: {
      root: {
        fontSize: "16px !important"
      }
    },
    MuiInputLabel: {
      root: {
        color: "#ff9800",
        fontSize: "20px !important"
      }
    },
    MuiTableRow: {
      root: {
        fontSize: "16px !important"
      }
    },
    MuiButton: {
      // override the styles of all instances of this component
      root: {
        // Name of the rule
        color: "#000000", // Some CSS
        backgroundColor: "white"
      },
      containedPrimary: {
        backgroundColor: "orange", // Some CSS
        cursor: "pointer",
        color: "black",
        "&:hover": {
          textDecoration: "none",
          backgroundColor: "orange",
          "@media (hover: none)": {
            backgroundColor: "transparent"
          },
          "&$disabled": {
            backgroundColor: "transparent"
          }
        }
      },
      textPrimary: {
        color: "black" // Some CSS
      }
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: "#323232 !important",
        color: "#fff !important"
      }
    },
    MuiSnackbar: {
      root: {
        zIndex: 14000,
        "& .MuiSnackbarContent-root": {
          backgroundColor: "#323232 !important",
          color: "#fff !important",
          "&[data-type='success']": {
            backgroundColor: "#4caf50 !important",
            color: "#fff !important"
          },
          "&[data-type='error']": {
            backgroundColor: "#f44336 !important",
            color: "#fff !important"
          },
          "&[data-type='warning']": {
            backgroundColor: "#ff9800 !important",
            color: "#fff !important"
          },
          "&[data-type='info']": {
            backgroundColor: "#2196f3 !important",
            color: "#fff !important"
          }
        }
      }
    }
  }
});

export default ImtbikeTheme;



// WEBPACK FOOTER //
// ./src/ImtbikeTheme.js